export const PRODUCT_LIST_KEY = 'PRODUCT_LIST';
export const PRODUCT_PROVIDER_LIST_KEY = 'PRODUCT_PROVIDER_LIST_KEY';
export const PRODUCTS_CATEGORY_LIST_KEY = 'PRODUCTS_CATEGORY_LIST_KEY';
export const PRODUCTS_WAREHOUSE_STOCK = 'PRODUCTS_WAREHOUSE_STOCK';
export const PRODUCTS_VARIANT_STOCK = 'products-variant-stock';

export const PRODUCTS_WAREHOUSE_STOCK_CAUSES_LIST_KEY = 'PRODUCTS_WAREHOUSE_STOCK_CAUSES_LIST_KEY';

export const PRODUCTS_RATE_LIST = 'PRODUCTS_RATE_LIST';
export const PROVIDER_LIST_KEY = 'PROVIDER_LIST_KEY';

export const MANUFACTURER_PRODUCTS_LIST_KEY = 'MANUFACTURER_PRODUCTS_LIST_KEY';

export const PRODUCT_VARIANTS = 'PRODUCT_VARIANTS';

export const COMBO_AVAILABILITY_KEY = 'COMBO_AVAILABILITY_KEY';
export const COMBO_COMPONENTS_LIST_KEY = 'COMBO_COMPONENTS_LIST_KEY';
